import Vue from 'vue';
import { TAB_STATUS, TAB_TYPES } from '../../../constants';

export const mutations = {
    SET_SEARCHTEXT(state, searchText) {
        state.searchText = searchText;
    },
    SET_SEARCHRESULTS(state, searchResults) {
        state.searchResults = searchResults;
    },
    SET_USERSEARCHES(state, userSearches) {
        state.userSearches = userSearches;
    },
    SET_TAB_OBJECT_SEARCH(state, dataObj) {
        state.pointerFocus = undefined;
        if (dataObj?.title) {
            state.tabObjectSearch = dataObj;
        } else {
            state.tabObjectSearch = null;
        }
    },
    SET_OBJECT_DATA_LOADING_TAB(state, { title }) {
        // create minimal empty object search result
        const obj = {
            title,
            data: {
                'items': [],
                'fields': []
            },
            maxResultsExceeded: false,
            count: 0,
            status: TAB_STATUS.LOADING
        };

        state.objectSearchResults.push(obj);
        const tabOrderObj = {
            title: obj.title,
            type: TAB_TYPES.ADMIN,
            status: obj.status,
        };
        const index = state.tabOrder.findIndex(i => i.title === obj.title);
        if (index !== -1) {
            Vue.set(state.tabOrder, index, tabOrderObj);
        } else {
            state.tabOrder.push(tabOrderObj);
        }
    },
    SET_TAB_TO_FOCUS(state, { title }) {
        state.tabToFocus = title;
    },
    UPDATE_LOADING_OBJECT_DATA(state, obj) {
        let index = state.objectSearchResults.findIndex(i => i.title === obj.title);
        if (index !== -1) {
            Vue.set(state.objectSearchResults, index, obj);
        } else {
            state.objectSearchResults.push(obj);
        }
        const tabOrderObj = {
            title: obj.title,
            type: TAB_TYPES.ADMIN,
            status: obj.status,
        };
        index = state.tabOrder.findIndex(i => i.title === obj.title);
        if (index !== -1) {
            Vue.set(state.tabOrder, index, tabOrderObj);
        } else {
            state.tabOrder.push(tabOrderObj);
        }
    },
    UPDATE_OBJECT_DATA_AUTO_OPENED_RELATION(state, index) {
        if (state.objectSearchResults[index]) {
            state.objectSearchResults[index].relationIsOpened = true;
        }
    },
    UPDATE_OBJECT_DATA_FEATURES(state, { index, features }) {
        state.objectSearchResults[index].data.features = features;
    },
    CLEAR_OBJECT_DATA(state, { title }) {
        if (title) {
            const index = state.objectSearchResults.findIndex(i => i.title === title);
            if (index !== -1) {
                state.objectSearchResults.splice(index, 1);
            }
        } else {
            state.objectSearchResults = [];
        }
        // Clear TabObjectsearch when no results remain.
        if (state.objectSearchResults.length === 0) {
            state.tabObjectSearch = null;
        }
    },
    CLEAR_TAB_TO_FOCUS(state) {
        state.tabToFocus = null;
    },
    CLEAR_TABORDER_DATA(state, { title }) {
        if (title) {
            if (state.tabOrder.length !== 0) {
                const index = state.tabOrder.findIndex(tO => tO.title === title);
                if (index !== -1) {
                    state.tabOrder.splice(index, 1);
                }
            }
        } else {
            state.tabOrder = [];
        }
    },
    CLEAR_TABORDER_RIGHT(state, { title }) {
        // if there is a title and there are tabOrder entries
        // find the title in the tabOrder
        if (title && state.tabOrder.length !== 0) {
            const index = state.tabOrder.findIndex(tO => tO.title === title);

            // if title is found delete all entries behind this one.
            if (index !== -1) {
                state.tabOrder.splice(index + 1);
            }
        }
    },
    SET_SELECTION_OBJECT_DATA_POINTER(state, { group = null, index = 0 }) {
        state.selectedObjectDataGroupIndex = typeof group === 'number' ? group : state.selectedGroupIndex;
        state.selectedObjectDataItemIndex = index;
    },
    SET_TABLE_SEARCHRESULTS(state, tableSearchResults) {
        state.tableSearchResults = tableSearchResults;
    },
    UPDATE_OBJECT_DATA_ITEMS(state, { title, items }) {
        const obj = state.objectSearchResults.find(
            (i) => i.title === title
        );
        if (obj?.data?.items) {
            obj.data.items = items;
        }
    }
};
